var magicStyles = [":host{display:contents}.experiment-vwo{display:contents}"];

export default magicStyles;
